export default "__VITE_ASSET__922cf521__"